import { find } from 'lodash/fp';
import { HttpStatusCodeGroup } from '@mews/enums';

export const getHttpStatusCodeGroup = (statusCode: number) =>
    find(({ value }) => value.from <= statusCode && statusCode <= value.to, HttpStatusCodeGroup.enumValues);

export default {
    getHttpStatusCodeGroup,
};
